<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            :main_icon="main_icon"
            :bgColor="bgColor"
            :icons="icon_data"
            :load_url="load_url"
            :hasLinks="hasLinks"
            :title="title">
    </DashboardCard>
</template>

<script>
    import DashboardCard from '../../widgets/DashboardCard';
    export default {
        name: 'ComplianceFlags',
        components: {DashboardCard},
        props: {
            dataDisplay: {type:String, default: null},
            bgColor: {type: String, default: 'light'},
            width: {type: Number, default: 100}
        },
        data() {
            return {
                hasLinks: true,
                main_icon: 'fa-light fa-flag',
                color: '#d53a00',
                title: 'Compliance Flags',
                load_url: '/dashboards/ComplianceFlags',
                icon_data: [
                    {
                        name: 'PFA - Other',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=22',
                        text_color: '#555'
                    },
                    {
                        name: 'PFA - # of Transactions',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=43&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                        text_color: '#555'
                    },
                    {
                        name: 'PFA - Dup Phone',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=41&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                        text_color: '#555'
                    },
                    {
                        name: 'PFA - Dup ID',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=40&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                        text_color: '#555'
                    },
                    {
                        name: 'PFA - Dup Banking',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=42&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                        text_color: '#555'
                    },
                    {
                        name: 'PFA - Multiple Same Item',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=50&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                        text_color: '#555'
                    },
                    {
                        name: 'PFA - Tags',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=38&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                        text_color: '#555'
                    },
                    {
                        name: 'PFA - Weight',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=48&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                        text_color: '#555'
                    },
                    {
                        name: 'PFA - Quantity',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=45&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                        text_color: '#555'
                    },
                    {
                        name: 'PFA - Engraving',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=44&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                        text_color: '#555'
                    },
                    {
                        name: 'PFA - Serial Number',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=39&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                        text_color: '#555'
                    },
                    {
                        name: 'PFA - Altered Melted',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=47&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                        text_color: '#555'
                    },
                    {
                        name: 'PFA - Altered Cut',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=46&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                        text_color: '#555'
                    },
                    {
                        name: 'Missing Information',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=3',
                        text_color: '#555'
                    },
                    {
                        name: 'Claim - Outbound',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=20',
                        text_color: '#555'
                    },
                    {
                        name: 'Claim - Inbound',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=21',
                        text_color: '#555'
                    },
                    {
                        name: 'Release of Claims',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=51',
                        text_color: '#555'
                    },
                    {
                        name: 'On-hold OFAC',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=customer_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=23',
                        text_color: '#555'
                    },
                    {
                        name: 'Anti Money Laundering',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=customer_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=17&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=equals&filterValue_1=9',
                        text_color: '#555'
                    },
                    // {
                    //     name: 'Additional Insurance ',
                    //     url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=28&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12&filterField_2=status_id&filterModel_2=order&filterName_2=Order%20Status&filterParameter_2=not%20equal%20to&filterValue_2=13&filterField_3=status_id&filterModel_3=order&filterName_3=Order%20Status&filterParameter_3=not%20equal%20to&filterValue_3=15&filterField_4=status_id&filterModel_4=order&filterName_4=Order%20Status&filterParameter_4=not%20equal%20to&filterValue_4=14',
                    //     text_color: '#555'
                    // },
                    {
                        name: 'Compliance Return',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=58',
                        text_color: '#555'
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>